import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { map, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { MainTabEnum } from '../../../enums/main-tabs';
import * as fromOfficeSelectors from '../../../store/selectors/office.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-tabs-layout',
  standalone: false,
  templateUrl: './tabs-layout.component.html'
})
export class TabsLayoutComponent {
  private store = inject(Store);
  private router = inject(Router);

  activeTab: MainTabEnum = MainTabEnum.PropertySearch;
  availableTabs = MainTabEnum;

  calculatorsEnabled$: Observable<boolean>;
  netSheetEnabled$: Observable<boolean>;
  walkingFarmEnabled$: Observable<boolean>;
  contactCardEnabled$: Observable<boolean>;

  propertyNavigationEnabled$: Observable<boolean>;
  propertyNavigationWalkingFarmId: string | null = null;
  propertyNavigationPropertyId: string | null = null;

  constructor() {
    this.calculatorsEnabled$ = this.store.pipe(select(fromOfficeSelectors.selectCalculatorsEnabled));
    this.netSheetEnabled$ = this.store.pipe(select(fromOfficeSelectors.selectNetSheetsEnabled));
    this.walkingFarmEnabled$ = this.store.pipe(select(fromOfficeSelectors.selectWalkingFarmEnabled));
    this.contactCardEnabled$ = this.store.pipe(select(fromOfficeSelectors.selectContactCardEnabled));
    this.propertyNavigationEnabled$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event) => {
        const routeRegExp = /^\/walking-farm\/(?<farmId>.*)\/view\/property\/(?<propertyId>[^/]*)$/;
        const hasPropertyNavigation = routeRegExp.test(event.urlAfterRedirects);
        this.propertyNavigationWalkingFarmId = null;
        this.propertyNavigationPropertyId = null;
        if (hasPropertyNavigation) {
          const match = `${event.urlAfterRedirects}`.match(routeRegExp);
          if (match) {
            this.propertyNavigationWalkingFarmId = match[1];
            this.propertyNavigationPropertyId = match[2];
          }
        }
        return hasPropertyNavigation;
      })
    );
  }

  setCurrentTab(event: { tab: string }) {
    if (Object.values(MainTabEnum).includes(event.tab as MainTabEnum)) {
      this.activeTab = event.tab as MainTabEnum;
    } else {
      this.activeTab = MainTabEnum.PropertySearch;
    }
  }
}
